import {CartesianGrid, Line, LineChart, ReferenceArea, XAxis, YAxis} from 'recharts';
import {match, Pattern} from 'ts-pattern';

import type {ReportDocumentSection} from './ChartReportDocument';
import {DOCUMENT_CHART_COLORS} from './DOCUMENT_CHART_COLORS';

const AXIS_LABEL_WIDTH = 70;

interface DocumentLineChartProps {
  data: Record<string, number | string | null>[];
  formatAxisValue: (value: number) => string;
  height: number;
  section: ReportDocumentSection;
  width: number;
}

export function DocumentLineChart(props: DocumentLineChartProps) {
  const targetRange = props.section.targetRange;
  return (
    <LineChart width={props.width} height={props.height} data={props.data}>
      <CartesianGrid vertical={false} stroke={DOCUMENT_CHART_COLORS.grid} />
      <XAxis
        dataKey="category"
        interval={Math.max(
          0,
          Math.ceil(
            props.section.categories.length /
              Math.max(2, Math.floor(props.width / AXIS_LABEL_WIDTH))
          ) - 1
        )}
        axisLine={false}
        tickLine={false}
        tick={{fontSize: 11, fill: DOCUMENT_CHART_COLORS.axisLabel}}
      />
      <YAxis
        domain={[
          (minimum: number) => Math.min(0, minimum, targetRange?.min ?? 0),
          targetRange ? (maximum: number) => Math.max(maximum, targetRange.max) : 'auto',
        ]}
        axisLine={false}
        tickLine={false}
        tickFormatter={props.formatAxisValue}
        tick={{fontSize: 11, fill: DOCUMENT_CHART_COLORS.axisLabel}}
        width={42}
      />
      {match(targetRange)
        .with(Pattern.nonNullable, (range) => (
          <ReferenceArea
            y1={range.min}
            y2={range.max}
            fill={range.color}
            fillOpacity={0.12}
            ifOverflow="extendDomain"
          />
        ))
        .otherwise(() => null)}
      {props.section.series.map((series, index) => (
        <Line
          key={series.id}
          dataKey={`series${index}`}
          name={series.label}
          type="linear"
          stroke={series.color}
          strokeWidth={2}
          strokeDasharray={series.strokeDasharray}
          dot={{r: 2}}
          connectNulls={false}
          isAnimationActive={false}
        />
      ))}
    </LineChart>
  );
}
